import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLingui } from '@lingui/react/macro';

interface Props {
  dataTestId?: string;
  expanded: boolean;
  onChange: (value: boolean) => void;
}

export const ViewAllButton = ({ dataTestId, expanded, onChange }: Props) => {
  const { t } = useLingui();
  const label = expanded ? t`View less` : t`View all`;

  return (
    <button
      className="vai-flex vai-items-center vai-gap-2 vai-p-2 vai-text-[#3961E6] vai-cursor-pointer vai-bg-transparent vai-border-none"
      data-testid={dataTestId}
      onClick={() => onChange(!expanded)}
    >
      <p className="vai-font-inter vai-text-[12px] vai-underline">{label}</p>
      <FontAwesomeIcon icon={expanded ? faAngleUp : faAngleDown} />
    </button>
  );
};
